import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import "./Header.css";
import urbanLuxeLogo from "../Favicon/urban-luxe-logo-1.png";

function Header() {
  const [offsetY, setOffsetY] = useState(0);
  const [isSticky, setIsSticky] = useState(false);
  const headerRef = useRef(null);
  const [fadein, setFadein] = useState(false);

  useEffect(() => {
    const handleScroll = () => setOffsetY(window.pageYOffset);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Intersection Observer for sticky nav
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsSticky(!entry.isIntersecting),
      { threshold: 0 }
    );
    if (headerRef.current) observer.observe(headerRef.current);
    return () => {
      if (headerRef.current) observer.unobserve(headerRef.current);
    };
  }, []);

  // Fading In For The Navigation //
  useEffect(() => {
    setTimeout(() => {
      setFadein(true);
    }, 2000); // You can go longer if you want more delay
  }, []);

  const maxScale = 1.5;
  const scrollLimit = 1700;
  const scale = 1 + Math.min(offsetY / scrollLimit, maxScale - 1);

  return (
    <header className="header" ref={headerRef}>
      <div
        className="background-zoom"
        style={{ transform: `scale(${scale})` }}
      ></div>

      <div className="overlay"></div>
      <motion.nav
        className={`nav ${isSticky ? "sticky-nav" : ""}`}
        initial={{ opacity: 0, x: -1200 }}
        animate={{
          opacity: fadein ? 1 : 0,
          x: fadein ? 0 : -1200,
          position: isSticky ? "fixed" : "relative",
          top: isSticky ? 0 : "auto",
          backgroundColor: isSticky
            ? "rgba(17,17,17,1)"
            : "rgba(17, 17, 17, 0.5)",
          boxShadow: isSticky ? "0 2px 10px rgba(0,0,0,0.1)" : "none",
          width: "100%",
          zIndex: 10,
        }}
        transition={{ duration: 2.2 }}
      >
        <img src={urbanLuxeLogo} alt="Urban Luxe Logo" className="logo" />
        <a href="#" className="nav-link">
          home
        </a>
        <a href="#" className="nav-link">
          our brand identity
        </a>
        <a href="#" className="nav-link">
          find your property
        </a>
        <a href="#" className="nav-link">
          meet the agents
        </a>
        <a href="#" className="nav-link">
          location highlights
        </a>
        <a href="#" className="nav-link contact-link">
          contact
        </a>
      </motion.nav>
      <div className="header-content-wrapper">
        <h1 className="header-title">find your space in the city of dreams</h1>
        <p className="header-text-description">
          discover handpicked luxury homes crafted for bold urban lifestyles and
          elegant comfort. with urban luxe, your dream adress is just the
          beggining.
        </p>
        <div className="btn-holder">
          <a href="#" className="cta-btn">
            start your luxe journey
          </a>
          <a href="#" className="learn-more-btn">
            experience urban-luxe
          </a>
        </div>
      </div>
    </header>
  );
}
export default Header;
